module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/097fb032029a18d346eb4e0662bdd41b.png";